module.exports = __webpack_public_path__ + "static/media/top3.7daa4e45.webp";